var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuNotifiche({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938.53,661.45h-10.66c-40.52,0-74.64-34.12-74.64-74.64v-245.25C853.22,147.49,691.14-8.2,494.94.33,311.53,8.87,170.78,166.68,170.78,352.22v236.72c0,40.52-34.12,72.51-74.64,72.51h-10.66C38.55,661.45.17,701.97.17,748.89v31.99c0,14.93,14.93,29.86,31.99,29.86h959.69c17.06,0,31.99-14.93,31.99-31.99v-31.99c0-46.92-38.39-85.31-85.31-85.31h0ZM616.5,896.04h-209c-12.8,0-23.46,12.8-21.33,25.59,10.66,59.71,63.98,102.37,125.83,102.37s115.16-44.79,125.83-102.37c2.13-12.8-8.53-25.59-21.33-25.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNotifiche);
export default __webpack_public_path__ + "static/media/menu-notifiche.8006bf01b275cfaa71c5a4e7d82f700b.svg";
export { ForwardRef as ReactComponent };